import { FLITCHING_HISTORY_LIST_FAILED, FLITCHING_HISTORY_LIST_REQUEST, FLITCHING_HISTORY_LIST_SUCCESS } from "../../../../actions/Factory/Flitching/flitchingHistoryListing/constants";

const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const flitchingHistoryReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FLITCHING_HISTORY_LIST_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCHING_HISTORY_LIST_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCHING_HISTORY_LIST_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};